import { DevOpsRepositoryPlatform, TaskEditModel } from "./generated";

/**
 * Creates a new TaskEditModel with default values.
 * @returns a new TaskEditModel with default values.
 */
export function createTask(): TaskEditModel {
    return {
        isParentTask: false,
        parentTaskId: null,
        editing: undefined,
        id: 0,
        clientName: "",
        projectName: "",
        priority: null,
        userId: 0,
        username: "",
        name: "",
        taskComment: "",
        devPlan: null,
        devSpent: null,
        devRemain: null,
        qaPmPlan: null,
        qaPmSpent: null,
        qaPmRemain: null,
        totalSpent: null,
        totalQuote: null,
        totalRemain: 0,
        externalLink: "",
        dueDate: null,
        dueDateDescription: "",
        startDate: null,
        taskStatusId: 0,
        clientId: null,
        projectId: null,
        isUrgent: false,
        externalTaskId: "",
        description: "",
        releaseNumber: "",
        hasInternalLinks: false,
        feedbackCount: null,
        leadId: null,
        toDoCount: null,
        canAddPullRequests: false,
        devOpsDefaultProjectId: "",
        gitHubDefaultRepository: "",
        repositoryPlatform: DevOpsRepositoryPlatform
    };
}
